export function aggregateSum(leafNodes, dataField, isPercentage = false) {
  var result = 0;
  leafNodes.forEach((node) => {
    const currentValue = Number(node.data[dataField]) || 0;
    if (isNaN(node.id) && (!node.data || (!node.data.row_id || node.data.row_id == '+'))) {
      return;
    }
    result += currentValue;
    return 0;
  });
  return isPercentage ? (result*100).toFixed(2) : result.toFixed(2);
}

export function aggregateAverage(leafNodes, dataField, isPercentage = false) {
  var result = 0;
  let notNumberValuesCount = 0;
  let length = 0
  leafNodes.forEach((node) => {
    if (isNaN(node.id) && (!node.data || (!node.data.row_id || node.data.row_id == '+'))) {
      return;
    }
    const currentValue = Number(node.data[dataField]);
    if (isNaN(currentValue)) {
      notNumberValuesCount++;
      return;
    }

    result += currentValue;
    length+=1
    return 0;
  });
  result = (result / (length - notNumberValuesCount));
  return isPercentage ? (result*100).toFixed(2) : result.toFixed(2)
}

export function aggregateMaximum(leafNodes, dataField, isPercentage = false) {
  var result = 0,
    initialValueStored = false;
  leafNodes.forEach((node) => {
    if (isNaN(node.id) && (!node.data || (!node.data.row_id || node.data.row_id == '+'))) {
      return;
    }
    const currentValue = Number(node.data[dataField]) || 0;

    if (!initialValueStored) {
      result = currentValue;
      initialValueStored = true;
    }
    if (result < currentValue) {
      result = currentValue;
    }
    return 0;
  });
  return isPercentage ? (result*100).toFixed(2) : result.toFixed(2);
}

export function aggregateMinimum(leafNodes, dataField, isPercentage = false) {
  var result = 0,
    initialValueStored = false;
  leafNodes.forEach((node) => {
    if (isNaN(node.id) && (!node.data || (!node.data.row_id || node.data.row_id == '+'))) {
      return;
    }
    const currentValue = Number(node.data[dataField]) || 0;

    if (!initialValueStored) {
      result = currentValue;
      initialValueStored = true;
    }
    if (result > currentValue) {
      result = currentValue;
    }
    return 0;
  });
  return isPercentage ? (result*100).toFixed(2) : result.toFixed(2);
}
